import React, { Component } from 'react';

class AvatarIcon extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imgError: false,
      fallbackError: false,
    };
  }

  handleImgError = () => {
    // First failure → use local fallback image
    if (!this.state.imgError) {
      this.setState({ imgError: true });
    } else {
      // If even the local fallback fails → show letter
      this.setState({ fallbackError: true });
    }
  };

  render() {
    const { organizationName, avatarUrl, label } = this.props;
    // const { imgError, fallbackError } = this.state;

    // let imageToShow = null;

    // if (!fallbackError) {
    //   imageToShow = !imgError && avatarUrl ? avatarUrl : '/assets/images/fallback.png';
    // }

    return (
      <div className="client-section">
        <div className="avatar-circle">
          {avatarUrl ? (
            <img
              src={avatarUrl}
              alt={organizationName}
              onError={this.handleImgError}
              style={{
                width: '100%',
                height: '100%',
                borderRadius: '50%',
                objectFit: 'cover',
              }}
            />
          ) : (
            organizationName?.charAt(0).toUpperCase()
          )}
        </div>
        <div className="client-info">
          <h5 className="client-name">{organizationName}</h5>
          <div className="client-subtitle">{label}</div>
        </div>
      </div>
    );
  }
}

export default AvatarIcon;
